<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">회원관리</span>
            <span class="txt">
                센터에 등록한 회원님을 검색하실 수 있으며, 회원님의 성함을 눌러 이용권 등록 및 마일리지 등록 등 회원님의
                다양한 설정을 진행하실 수 있습니다.
            </span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div style="display: flex; gap: 28px">
                <div class="photo-info-card">
                    <img
                        class="photo"
                        :src="customerInfo.imageUrl === null ? '/img/icons/no_photo.jpg' : customerInfo.imageUrl"
                        alt="사진"
                    />
                    <div class="info-txt">
                        <span class="txt name">{{ customerInfo.name + ` (${customerInfo.attendNo})` }}</span>
                        <span class="txt">{{ customerInfo.phone | customerPhoneFilter }}</span>
                        <span class="txt">{{ convertTeamGroupsToString(customerInfo.centerCustomerTeamGroups) }}</span>
                        <span class="txt">-</span>
                    </div>
                    <span v-if="customerInfo.status === 'V'" class="icon green">유효</span>
                    <span v-if="customerInfo.status === 'E'" class="icon red">만료</span>
                    <span v-if="customerInfo.status === '-'" class="icon gray">잠재</span>
                    <span v-if="customerInfo.status === 'H'" class="icon yellow">홀딩</span>
                    <!--<button class="send-btn">인증코드전송</button>-->
                </div>
                <div class="d-flex flex-column" style="margin-top: 35px">
                    <button
                        v-if="hasMessageEvent && customerInfo.mktAgreeSms"
                        class="com-btn white"
                        @click="routing('messageSend', customerInfo)"
                    >
                        메시지 발송
                    </button>
                    <button
                        v-show="isAllowed('ME', 6)"
                        class="com-btn white"
                        style="margin-top: 10px"
                        @click="showContractSendPopup()"
                    >
                        계약서 발송
                    </button>
                </div>

                <div class="info-card">
                    <div class="info-txt">
                        <span class="txt name">최근 수업일</span>
                        <span class="txt">{{ lastLessonDaysAgo }}일전</span>
                        <span class="txt">마지막 출석: {{ customerInfo.latestLessonAt | dateFormatFilter }}</span>
                    </div>
                </div>
            </div>
            <div class="com-tab">
                <button @click="onClickRouter('/madmin/member/info')">기본정보</button>
                <button @click="onClickRouter('/madmin/member/payment')">결제내역</button>
                <button class="on">예약/취소내역</button>
                <button @click="onClickRouter('/madmin/member/attend')">입장/출결내역</button>
                <button @click="onClickRouter('/madmin/member/mileage')">마일리지</button>
                <button
                    @click="
                        checkAllowedClick('MB', 3, () => {
                            onClickRouter('/madmin/member/advice');
                        })
                    "
                >
                    상담내역
                </button>
                <button @click="onClickRouter('/madmin/member/message')">메시지발송내역</button>
                <button v-show='isAllowed("ME", 7)' @click="onClickRouter('/madmin/member/contract_send')">계약서발송내역</button>
            </div>

            <div class="com-search-content">
                <div class="line">
                    <div class="com-radio">
                        <input id="radio-day-1" v-model="searchDateType" name="radio-day" type="radio" value="S" />
                        <label for="radio-day-1">예약일자</label>
                    </div>
                    <div class="com-radio">
                        <input id="radio-day-2" v-model="searchDateType" name="radio-day" type="radio" value="L" />
                        <label for="radio-day-2">수업일자</label>
                    </div>
                    <div class="com-calendar-wrap">
                        <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                        <div class="com-dash"><span class="dash">~</span></div>
                        <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                    </div>
                    <select-form
                        :select-data="['선택', ...periodTypeList]"
                        :select-value="['', ...periodTypeValueList]"
                        :selected-value="searchPeriod"
                        @update:set="(val) => (searchPeriod = val)"
                    ></select-form>
                </div>
                <div class="line">
                    <select-form
                        :select-data="['강사명', ...centerStaffList]"
                        :select-value="['', ...centerStaffValueList]"
                        class="w220"
                        @update:set="(val) => (centerStaffId = val)"
                    ></select-form>
                    <select-form
                        :select-data="['예약상태', ...resvStatusCodeList]"
                        :select-value="['', ...resvStatusCodeValueList]"
                        @update:set="(val) => (reservationStatus = val)"
                    ></select-form>
                    <select-form
                        :select-data="['디바이스', ...atndDevCodeList]"
                        :select-value="['', ...atndDevCodeValueList]"
                        @update:set="(val) => (attendanceDevice = val)"
                    ></select-form>
                    <button class="com-search-reset" @click="resetSearchParams"></button>
                </div>
            </div>

            <div class="com-table-content">
                <table class="com-table">
                    <colgroup>
                        <col style="width: 180px" />
                        <col style="width: 480px" />
                        <col style="width: 180px" />
                        <col style="width: 140px" />
                        <col style="width: 140px" />
                        <col style="width: 140px" />
                        <col style="width: 140px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <button @click="onClickCreDtColumn">예약일자</button>
                            </th>
                            <th>
                                <button @click="onClickLessNmColumn">이용권명</button>
                            </th>
                            <th>
                                <button @click="onClickLessDtColumn">수업일자</button>
                            </th>
                            <th>
                                <button @click="onClickStaffNmColumn">강사명</button>
                            </th>
                            <th>
                                <button @click="onClickAtndStatusColumn">예약상태</button>
                            </th>
                            <th>
                                <button @click="onClickAtndDeviceColumn">디바이스</button>
                            </th>
                            <th>
                                <button @click="onClickResvNmColumn">예약주체</button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(r, index) in reservationList" :key="index">
                            <td>{{ r.cth_cre_dt | timestampFilter2 }}</td>
                            <td class="left">
                                <span
                                    :class="{
                                        ico: true,
                                        'type-1': r.cp_ticket_type_cd === 'P',
                                        'type-2': r.cp_ticket_type_cd === 'G',
                                        'type-4': r.cp_ticket_type_cd === 'T',
                                        'type-5': r.cp_ticket_type_cd === 'D',
                                        'type-6': r.cp_ticket_type_cd === 'O',
                                        'type-8': r.cp_ticket_type_cd === 'S',
                                    }"
                                >
                                    {{ convertTicketTypeFormat(r.cp_ticket_type_cd) }}
                                </span>
                                {{ r.ccp_prod_nm }}
                            </td>
                            <td>{{ r.cth_less_dt | timestampFilter3 }}</td>
                            <td>{{ r.cs_namee }}</td>
                            <td>
                                <span :class="{
                                    red:
                                        r.cth_resv_status_cd === 'RC' ||
                                        r.cth_resv_status_cd === 'CC' ||
                                        r.cth_resv_status_cd === 'WC',
                                }">{{ convertResvStatus(r.cth_resv_status_cd) }}</span>
                            </td>
                            <td>{{ convertAtndDevCode(r.cth_resv_dev_cd) }}</td>
                            <td>{{ r.upd_namee }}</td>
                        </tr>
                        <!--                    <tr>-->
                        <!--                        <td>2019-12-23 13:00:32</td>-->
                        <!--                        <td class="left">-->
                        <!--                            <span class="ico type-6">[OT]</span>-->
                        <!--                            필라테스 10회 PL + 개인레스 PL 10회-->
                        <!--                        </td>-->
                        <!--                        <td>2019-10-01(목) 19:00</td>-->
                        <!--                        <td>김윤경</td>-->
                        <!--                        <td>예약</td>-->
                        <!--                        <td>관리자 WEB</td>-->
                        <!--                        <td>홍길동</td>-->
                        <!--                    </tr>-->
                        <tr v-if="reservationList.length === 0">
                            <td colspan="100">등록된 내용이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
                <div class="sort-bottom-area">
                    <select-form
                        :select-data="[...sortTypeList]"
                        :select-value="[...sortTypeValueList]"
                        class="float-right"
                        @update:set="onChangeLimit"
                    ></select-form>
                </div>
                <b-pagination
                    v-model="pagingInfo.page"
                    :per-page="pagingInfo.limit"
                    :total-rows="pagingInfo.totalItems"
                    align="center"
                    aria-controls="my-table"
                    first-class="first"
                    last-class="last"
                    next-class="next"
                    prev-class="prev"
                    @change="handlerPagenation"
                ></b-pagination>
            </div>
        </template>
        <contract-send-dlg
            v-if="contractSendPop"
            :show="contractSendPop"
            :info="contractSendInfo"
            :close="handleCloseContractSend"
            :charge="handleCharge"
            :paymentLinkSend="handlePaymentLinkSend"
        ></contract-send-dlg>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import moment from 'moment';
import EventBus from '../../../assets/js/eventBus';
import { pagingInfo } from '@/assets/js/common';
import ContractSendDlg from '../../../components/ContractSendDlg';

export default {
    name: 'memberCancel',
    mixins: [MixinAllowedMenu],
    components: {
        ContractSendDlg,
    },
    props: {},
    computed: {
        lastLessonDaysAgo() {
            if (this.customerInfo.latestLessonAt) {
                return moment().startOf('day').diff(moment(this.customerInfo.latestLessonAt).startOf('day'), 'days');
            }

            return '-';
        }
    },
    watch: {
        searchPeriod(newValue) {
            // 검색 기간 설정 변수
            this.searchPeriod = newValue;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.initStartDate();
                this.initEndDate();
            }
        },
        startDate(newValue) {
            // 검색 시작일
            this.startDate = newValue;
        },
        endDate(newValue) {
            // 검색 종료일
            this.endDate = newValue;
        },
        searchDateType(newValue) {
            // 검색일자조건 (예약일자:S,수업일자:L)
            this.searchDateType = newValue;
            this.fetchReservationList();
        },
        centerStaffId(newValue) {
            // 강사명
            this.centerStaffId = newValue;
            this.fetchReservationList();
        },
        reservationStatus(newValue) {
            // 예약상태
            this.reservationStatus = newValue;
            this.fetchReservationList();
        },
        attendanceDevice(newValue) {
            // 디바이스
            this.attendanceDevice = newValue;
            this.fetchReservationList();
        },
    },
    mounted() {
        this.init();
    },
    data() {
        return {
            hasMessageEvent: false, // 메시지 계약되었을시..

            isLoading: false,
            centerId: this.$route.params.id,
            customerId: this.$route.query.customerId,
            customerInfo: {}, // 회원 정보
            reservationList: [], // 예약/취소 목록
            pagingInfo: { ...pagingInfo },

            centerStaffList: [],
            centerStaffValueList: [],
            resvStatusCodeList: ['예약', '예약대기', '취소', '대기취소', '변경예약', '변경취소'], // 예약 상태 코드 이름 (RR : 예약, RW: 예약대기, RC : 취소, CR : 변경예약, CC : 변경취소)
            resvStatusCodeValueList: ['RR', 'RW', 'RC', 'WC', 'CR', 'CC'], // 예약 상태 코드 값
            atndDevCodeList: ['관리자웹', '관리자앱', '회원앱', '자동예약'], // 출결 장비 코드 (AW : 관리자웹, AA : 관리자앱, CA : 회원앱, TU : 터치모니터)
            atndDevCodeValueList: ['AW', 'AA', 'CA', 'AU'], // 출결 장비 코드 값

            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],

            searchDateType: 'S', // 검색 파라미터 (검색일자조건) (예약일자:S,수업일자:L)
            startDate: '', // 검색 파라미터 (시작일)
            endDate: '', // 검색 파라미터 (종료일)

            centerStaffId: '', // 검색 파라미터 (강사명)
            reservationStatus: '', // 검색 파라미터 (예약상태)
            attendanceDevice: '', // 검색 파라미터 (디바이스)
            searchPeriod: '', // 검색 기간 설정

            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],

            resvSortType: 'DESC',
            resvSortColumn: '',

            contractSendPop: false,
            contractSendInfo: {},
            centerInfo: {},
        };
    },
    methods: {
        routing(toName, checkedUserData) {
            const routingData = [];
            console.log(checkedUserData);
            // checkedUserData.forEach((param) => {
            const tempValue = {
                ...checkedUserData,
            };
            routingData.push(tempValue);
            // });
            this.$router.push({
                name: toName,
                params: { data: routingData },
            });
        },

        checkMessageEvent() {
            return api
                .get('/admin/api/center/ftcontract/sms')
                .then((res) => {
                    this.hasMessageEvent = JSON.parse(res.data);
                })
                .catch((error) => {
                    this.hasMessageEvent = false;
                });
        },

        // 초기화
        async init() {
            this.isLoading = true;
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 10;
            await this.initStartDate(); // 검색 시작일 초기화
            await this.initEndDate(); // 검색 종료일 초기화
            await this.fetchCenterStaffList(); // 직원 목록 가져오기
            await this.fetchCustomerDetail(); // 회원 정보 가져오기
            // 예약/취소 목록 가져오기
            await this.fetchReservationList();
            await this.checkMessageEvent();
            this.getCenterInfo(); // 로그인한 센터 정보 가져오기
            this.isLoading = false;
        },
        // centerId 로 센터 정보 가져오기
        async getCenterInfo() {
            try {
                const { data } = await this.sendGetCenter();
                this.centerInfo = data;
            } catch (error) {
                console.log(error);
            }
        },

        // 센터 조회 API 호출
        sendGetCenter() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },

        // 회원 정보 가져오기
        async fetchCustomerDetail() {
            try {
                const { data } = await this.sendGetCustomerDetail();
                this.customerInfo = data;
                this.customerInfo.centerCustomerTeamGroups = this.customerInfo.centerCustomerTeamGroups.filter(
                    (g) => !g.centerCustomerTeam.info.deleteYn
                );
            } catch (error) {
                alert('회원정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 회원 기본정보 조회 API 호출
        sendGetCustomerDetail() {
            return api.get(`/admin/api/center/${this.centerId}/customer/${this.customerId}`);
        },

        // 예약/취소 목록 가져오기
        async fetchReservationList() {
            try {
                const { data } = await this.sendGetReservation();
                this.reservationList = data.items;
                this.setPageParams(data);
            } catch (error) {
                alert('예약/취소 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 예약/취소 목록 API 호출
        sendGetReservation() {
            const {
                searchDateType,
                startDate,
                endDate,
                centerStaffId,
                reservationStatus,
                attendanceDevice,
                customerId,
            } = this;
            const searchParams = {
                searchDateType,
                startDate,
                endDate,
                centerStaffId,
                reservationStatus,
                attendanceDevice,
                centerCustomerId: customerId,
            };
            const sortParams = {
                sortType: this.resvSortType, // 정렬방법 (오름차순 : ASC, 내림차순 : DESC)
                sortColumn: this.resvSortColumn, // 정렬컬럼 (createDate, lessonName, lessonDate, centerStaffname, attendanceStatus, attendanceDevice, reservationName)
            };
            return api.get(`/admin/api/center/${this.centerId}/lesson/schedule/customer/reservation/all`, {
                params: {
                    ...this.pagingInfo,
                    ...searchParams,
                    ...sortParams,
                },
            });
        },

        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({
                path: `${path}/${this.centerId}`,
                query: { customerId: this.customerId },
            });
        },

        // 회원 정보 카드에 나타낼 회원 그룹 이름 만들기
        convertTeamGroupsToString(teamGroups) {
            if (teamGroups === undefined) {
                return;
            }
            if (teamGroups.length === 1) {
                // 그룹이 1개일 경우
                return teamGroups[0].centerCustomerTeamName;
            } else if (teamGroups.length === 0) {
                // 그룹이 없을 경우
                return '-';
            } else if (teamGroups.length > 1) {
                // 그룹이 여러개일 경우
                return `${teamGroups[0].centerCustomerTeamName} 외 ${teamGroups.length - 1}`;
            }
        },

        // 직원(상담자) 목록 가져오기
        async fetchCenterStaffList() {
            try {
                const { data } = await this.sendGetCenterStaffList();
                data.forEach((d) => {
                    this.centerStaffList.push(d.name);
                    this.centerStaffValueList.push(d.centerStaffId);
                });
            } catch (error) {
                alert('직원 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 직원 목록 API 호출
        sendGetCenterStaffList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },

        // 검색 시작일 초기화
        initStartDate() {
            const startDate = moment().subtract(1, 'months').format('YYYY-MM-DD');
            this.startDate = startDate;
        },

        // 검색 종료일 초기화
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            this.endDate = endDate;
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.fetchReservationList();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.fetchReservationList();
        },

        // 검색 조건 초기화
        resetSearchParams() {
            this.initStartDate(); // 시작일 검색 파라미터
            this.initEndDate(); // 종료일 검색 파라미터
            this.searchPeriod = '';
            this.centerStaffId = '';
            this.reservationStatus = '';
            this.attendanceDevice = '';
            this.searchDateType = 'S';
            this.fetchReservationList();
            EventBus.$emit('event:initList', 'init');
        },

        // 예약 상태 String 변환
        convertResvStatus(resvStatusCode) {
            if (resvStatusCode === 'RR') {
                return '예약';
            } else if (resvStatusCode === 'RW') {
                return '예약대기';
            } else if (resvStatusCode === 'RC') {
                return '취소';
            } else if (resvStatusCode === 'CR') {
                return '변경예약';
            } else if (resvStatusCode === 'CC') {
                return '변경취소';
            } else if (resvStatusCode === 'WC') {
                return '대기취소';
            }
            return '';
        },

        // 예약 상태 String 변환
        convertAtndDevCode(atndDevCode) {
            if (atndDevCode === 'AW') {
                return '관리자웹';
            } else if (atndDevCode === 'AA') {
                return '관리자앱';
            } else if (atndDevCode === 'CA') {
                return '회원앱';
            } else if (atndDevCode === 'AU') {
                return '자동예약';
            }
            return '';
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.fetchReservationList();
        },

        // 페이징 Param set
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        // 이용권 코드 변환
        convertTicketTypeFormat(type) {
            if (type === 'P') {
                return '[개인]';
            } else if (type === 'O') {
                return '[OT]';
            } else if (type === 'D') {
                return '[듀엣]';
            } else if (type === 'G') {
                return '[그룹]';
            } else if (type === 'C') {
                return '[쿠폰]';
            } else if (type === 'T') {
                return '[회원권]';
            } else if (type === 'S') {
                return '[운동복]';
            }
            return '';
        },

        // 한 페이지에 표시되는 줄 수 변경
        onChangeLimit(val) {
            this.pagingInfo.limit = val;
            this.fetchReservationList();
        },

        // 예약일자 컬럼 클릭시
        onClickCreDtColumn() {
            this.resvSortColumn = 'createDate';
            if (this.resvSortType === '' || this.resvSortType === 'DESC') {
                this.resvSortType = 'ASC';
            } else {
                this.resvSortType = 'DESC';
            }
            this.fetchReservationList();
        },

        // 이용권명 컬럼 클릭시
        onClickLessNmColumn() {
            this.resvSortColumn = 'lessonName';
            if (this.resvSortType === '' || this.resvSortType === 'DESC') {
                this.resvSortType = 'ASC';
            } else {
                this.resvSortType = 'DESC';
            }
            this.fetchReservationList();
        },

        // 수업일자 컬럼 클릭시
        onClickLessDtColumn() {
            this.resvSortColumn = 'lessonDate';
            if (this.resvSortType === '' || this.resvSortType === 'DESC') {
                this.resvSortType = 'ASC';
            } else {
                this.resvSortType = 'DESC';
            }
            this.fetchReservationList();
        },

        // 강사명 컬럼 클릭시
        onClickStaffNmColumn() {
            this.resvSortColumn = 'centerStaffname';
            if (this.resvSortType === '' || this.resvSortType === 'DESC') {
                this.resvSortType = 'ASC';
            } else {
                this.resvSortType = 'DESC';
            }
            this.fetchReservationList();
        },

        // 예약상태 컬럼 클릭시
        onClickAtndStatusColumn() {
            this.resvSortColumn = 'attendanceStatus';
            if (this.resvSortType === '' || this.resvSortType === 'DESC') {
                this.resvSortType = 'ASC';
            } else {
                this.resvSortType = 'DESC';
            }
            this.fetchReservationList();
        },

        // 디바이스 컬럼 클릭시
        onClickAtndDeviceColumn() {
            this.resvSortColumn = 'attendanceDevice';
            if (this.resvSortType === '' || this.resvSortType === 'DESC') {
                this.resvSortType = 'ASC';
            } else {
                this.resvSortType = 'DESC';
            }
            this.fetchReservationList();
        },

        // 예약주체 컬럼 클릭시
        onClickResvNmColumn() {
            this.resvSortColumn = 'reservationName';
            if (this.resvSortType === '' || this.resvSortType === 'DESC') {
                this.resvSortType = 'ASC';
            } else {
                this.resvSortType = 'DESC';
            }
            this.fetchReservationList();
        },
        getReservationId(r) {
            //              예약자 타입,        예약자 이름?, 예약자고객이름,  수업강사명,   고객명..
            // console.log(r.cth_resv_type_cd, r.rcs_namee, r.rcust_namee, r.cs_namee, r.cust_namee);
            let answer = '';
            if (r.cth_resv_type_cd === 'S') {
                answer = r.rcs_namee;
            } else if (r.cth_resv_type_cd === 'C') {
                answer = r.rcust_namee;
            }
            return answer;
        },

        handleCloseContractSend() {
            this.contractSendPop = false;
        },

        handleCharge() {
            this.contractSendPop = false;
        },

        handlePaymentLinkSend() {
            this.contractSendPop = false;

            this.onClickRouter('/madmin/member/contract_send');
        },

        showContractSendPopup() {
            this.contractSendInfo = {
                centerId: this.centerId,
                centerName: this.centerInfo.centerName,
                customerId: this.customerId,
                customerName: this.customerInfo.name,
                customerPhone: this.customerInfo.phone,
                templateType: 'M',
            };
            this.contractSendPop = true;
        },
    },
};
</script>
<style lang="scss"></style>
